import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoGridOneColumn,
    RaikoButtonSecondary, RaikoFlexFirstChildGrowOne
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {RouteHelper} from "../../../route/RouteHelper";
import TabBoxContainer from "../../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import AccountDetailBasicInfo from "./AccountDetailBasicInfo";
import AccountTransactions from "./AccountTransactions";
import AccountMonthlyDeposit from "./AccountMonthlyDeposit";
import AccountDetailReports from "./AccountDetailReports";
import AccountDetailLoanInfo from "./AccountDetailLoanInfo";

export default function AccountDetail() {

    const {state: location} = useLocation()

    const navigate = useNavigate()
    const {id: accountId} = useParams()

    const [pageTitle, setPageTitle] = useState()

    useEffect(() => {
        if (location && location.title) {
            setPageTitle(location.title)
        }
    }, [location]);


    const [selectedTab, setSelectedTab] = useState(tabInfo.BASIC_INFO.id)

    const handleChangeTabMenu = (event, newValue) => {
        setSelectedTab(newValue)
    }

    return (
        <RaikoBaseContainer>
            <RaikoFlexFirstChildGrowOne>
                <RaikoBreadcrumb className={css`flex-grow: 1;
                  gap: .5rem;`} breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.AccountsList.name,
                        RouteHelper.AccountsList.globalUrl
                    ),
                    raikoBreadCrumbItemGenerator(
                        pageTitle,
                        ""
                    )
                ]}/>

                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        navigate(-1);
                    }}/>
            </RaikoFlexFirstChildGrowOne>


            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <TabContext value={selectedTab}>
                    <TabBoxContainer>
                        <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={tabInfo.BASIC_INFO.title}
                                value={tabInfo.BASIC_INFO.id}/>
                            <Tab
                                label={tabInfo.LOAN_INFO.title}
                                value={tabInfo.LOAN_INFO.id}/>
                            <Tab
                                label={tabInfo.TRANSACTIONS.title}
                                value={tabInfo.TRANSACTIONS.id}/>
                            <Tab
                                label={tabInfo.MONTHLY_DEPOSITS.title}
                                value={tabInfo.MONTHLY_DEPOSITS.id}/>
                            <Tab
                                label={tabInfo.REPORTS.title}
                                value={tabInfo.REPORTS.id}/>
                        </TabList>
                    </TabBoxContainer>

                    <TabPanel value={tabInfo.BASIC_INFO.id}>
                        <AccountDetailBasicInfo
                            setUserFullName={fullName=>{
                                setPageTitle(fullName)
                            }}
                        />
                    </TabPanel>
                    <TabPanel value={tabInfo.LOAN_INFO.id}>
                        <AccountTransactions/>
                    </TabPanel>
                    <TabPanel value={tabInfo.TRANSACTIONS.id}>
                        <AccountMonthlyDeposit/>
                    </TabPanel>
                    <TabPanel value={tabInfo.MONTHLY_DEPOSITS.id}>
                        <AccountDetailLoanInfo accountId={accountId}/>
                    </TabPanel>
                    <TabPanel value={tabInfo.REPORTS.id}>
                        <AccountDetailReports/>
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}

const tabInfo = {
    BASIC_INFO: {
        id: "BASIC_INFO",
        title: "اطلاعات پایه"
    }, LOAN_INFO: {
        id: "LOAN_INFO",
        title: "گردش حساب"
    }, TRANSACTIONS: {
        id: "TRANSACTIONS",
        title: "واریز ماهانه"
    }, MONTHLY_DEPOSITS: {
        id: "MONTHLY_DEPOSITS",
        title: "امتیاز وام"
    }, REPORTS: {
        id: "REPORTS",
        title: "گزارشات"
    }
}
